import { InjectionToken } from '@angular/core';
import { PlatformConfig } from '../interfaces/config.interfaces';

/**
 * Injection token for platform configuration
 * Use this token to inject the platform configuration into your services and components
 */
export const PLATFORM_CONFIG = new InjectionToken<PlatformConfig>('PLATFORM_CONFIG');

